/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AssetManager } from './AssetManager';
import {
    AssetManagerFromJSON,
    AssetManagerFromJSONTyped,
    AssetManagerToJSON,
} from './AssetManager';

/**
 * 
 * @export
 * @interface AssetManagersViewModel
 */
export interface AssetManagersViewModel {
    /**
     * 
     * @type {Array<AssetManager>}
     * @memberof AssetManagersViewModel
     */
    assetManagers: Array<AssetManager>;
}

/**
 * Check if a given object implements the AssetManagersViewModel interface.
 */
export function instanceOfAssetManagersViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "assetManagers" in value;

    return isInstance;
}

export function AssetManagersViewModelFromJSON(json: any): AssetManagersViewModel {
    return AssetManagersViewModelFromJSONTyped(json, false);
}

export function AssetManagersViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetManagersViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'assetManagers': ((json['AssetManagers'] as Array<any>).map(AssetManagerFromJSON)),
    };
}

export function AssetManagersViewModelToJSON(value?: AssetManagersViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'AssetManagers': ((value.assetManagers as Array<any>).map(AssetManagerToJSON)),
    };
}

